/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Box } from '@material-ui/core';
import LocationIcon from '@material-ui/icons/LocationOn';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import styles from './styles';

interface PropTypes {
  translationKey: string;
}
const GeolocationReason: React.FC<PropTypes> = ({ translationKey }) => {
  const tMdMultiline = useMarkdownMultilineTranslate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyItems="center"
      alignItems="center"
      mt={2}
      mb={2}
    >
      <LocationIcon fontSize="small" color="action" />
      <div css={styles.finePrint}>{tMdMultiline(translationKey)}</div>
    </Box>
  );
};

export default GeolocationReason;
